import { GetterTree } from 'vuex'

import { RootState, SlogState } from '@/types/store'

export const getters: GetterTree<SlogState, RootState> = {
  logs(state): SlogState['logs'] {
    return state.logs
  },
  isLogsLoading(state): SlogState['isLogsLoading'] {
    return state.isLogsLoading
  },
}
